import React, { useState, useCallback } from "react"
import { WEBSITE_NAME } from "config"
import { Link, Icon } from "ui"
import MainMenu, { useMainMenu } from "./MainMenu"

import LanguageSelector from "./LanguageSelector"

const useAnimation = (node, first) => {
    const hasRun = React.useRef()
    if (!hasRun.current) {
        if (!first || (node && node.bundle==='homepage') ) hasRun.current = true
    }
    React.useLayoutEffect(() => {
        if (hasRun.current || !node) return
        document.querySelector("#header").classList.add('loaded')
        hasRun.current = true
    }, [node])
}

const Header = ({ node, language, first }) => {
    useAnimation(node, first)
    const menu = useMainMenu()
    const [open, setOpen] = useState(false)
    const handleToggle = useCallback(() => {
        setOpen(open => !open)
    }, [])
    const handleClose = useCallback(() => {
        setOpen(false)
    }, [])
    const handleActivate = useCallback(() => {
        setOpen(false)
        return true
    }, [])
    const ignore = e => {
        e.stopPropagation()
    }

    return (
        <header role="banner" id="header" key="header">
            <Link id="logo" to="/">
                <Icon name="Logo" title={WEBSITE_NAME} />
                <div className="site-slogan"><div className="inner">
                    <strong>MPI</strong> STEELPROCESS
                </div></div>
            </Link>

            <div className='header-in'>
                <div className="full-view">
                    <LanguageSelector node={node} language={language} onActivate={handleActivate} />
                    <MainMenu
                        id="main-menu"
                        menu={menu}
                        language={language}
                        onActivate={handleActivate}
                    />
                </div>
                <button id="mobile-menu-button" onClick={handleToggle}>
                    <Icon name="Menu" size={48} />
                </button>

                <div className={`menu-wrap ${open ? "menu-open" : ""}`} onClick={handleClose}>
                    <div className="menu-container" onClick={ignore}>
                        <button id="menu-close" onClick={handleClose}>
                            <Icon name="SubArrowRight" size={48} />
                        </button>
                        <div className="menu-wrap-in">
                            <div>
                                <LanguageSelector
                                    node={node}
                                    language={language}
                                    onActivate={handleActivate}
                                />
                                <MainMenu
                                    menu={menu}
                                    language={language}
                                    onActivate={handleActivate}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}
export default React.memo(Header)
